export default "__VITE_ASSET__f2eeb67e__"